import { theme } from "antd";

const { useToken } = theme;
export const useGetToken = () => useToken();
